import React, { useState, useEffect } from "react";
import whatsapp from "../img/icon/whatsapp.png";

const Whatsapp = () => {
  const [position, setPosition] = useState({ bottom: "50px", right: "70px", height: "70px", width: "70px" });

  useEffect(() => {
    const updatePosition = () => {
      if (window.innerWidth < 576) {
        setPosition({ bottom: "31px", right: "25px", height: "60px", width: "60px" });
      } else {
        setPosition({ bottom: "50px", right: "70px", height: "70px", width: "70px" });
      }
    };

    window.addEventListener("resize", updatePosition);
    updatePosition(); // Call on mount

    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  return (
    <a
      href="https://wa.me/+918766551964"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        backgroundColor: "white",
        color: "white",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        borderRadius: "50%",
        fontSize: "24px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
        zIndex: 1100,
        textAlign: "center",
        ...position, // Apply dynamic styles
      }}
    >
      <img src={whatsapp} alt="" style={{ height: "44px", width: "44px" }} />
    </a>
  );
};

export default Whatsapp;
